import * as React from 'react';
import { useSelector } from 'react-redux';
import { EServiceId } from '../../../../../../types/reducers/publishTerms';
import {
  selectActiveOrPromotionServiceId,
  selectActiveServiceId,
  selectIsPromotionPackageSelected,
} from '../../../../../../selectors/publishTerms';
import { selectBaseAuctionBetByServiceId, selectCurrentBet } from '../../../../../../selectors/auction';

import { PremiumLabel, StandardLabel, TopBetLabel, TopLabel } from './labels';

export const PromotionLabelContainer = () => {
  const isPromotionPackageSelected = useSelector(selectIsPromotionPackageSelected);
  const activeOrPromotionServiceId = useSelector(selectActiveOrPromotionServiceId);
  const activeServiceId = useSelector(selectActiveServiceId);
  const baseAuctionBet: number = useSelector(
    selectBaseAuctionBetByServiceId(activeOrPromotionServiceId || EServiceId.top),
  );
  const currentBet = useSelector(selectCurrentBet);

  const isTopNotPromotion = !isPromotionPackageSelected;

  if (isTopNotPromotion && activeServiceId !== EServiceId.top) {
    return null;
  }

  if (isTopNotPromotion && activeServiceId === EServiceId.top) {
    return currentBet > baseAuctionBet ? <TopBetLabel /> : <TopLabel />;
  }

  switch (activeOrPromotionServiceId) {
    case EServiceId.top:
      return <TopLabel />;

    case EServiceId.premium:
      return <PremiumLabel />;

    default:
      return <StandardLabel />;
  }
};
